/**
 *
 * @/functions/datetime.js
 *
 * Description:
 * A vanilla JavaScript replacement for Moment.js
 *
 */

export const parseYYYYMD = dateStr => {
  const [y, m, d] = dateStr.split('-').map(Number)
  return new Date(y, m - 1, d) // local, sem UTC
}

export const formatDDMMYYYY = date => {
  const d = String(date.getDate()).padStart(2, '0')
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const y = date.getFullYear()
  return `${d}/${m}/${y}`
}
